











/* ----------------------------------------
    Imports
---------------------------------------- */

import UserJob from '@job/UserJob';
import { Component, Vue } from 'vue-property-decorator';
import { mapGetters } from 'vuex';
import { StoreMixin } from '@mixin/store';
import PageHeader from '@part/layout/PageHeader.vue';
import PageView from '@part/layout/PageView.vue';
import PageFooter from '@part/layout/PageFooter.vue';

/* ----------------------------------------
    Component
---------------------------------------- */

@Component({

    data() {
        return {
            hideFooter: false,
            appLoaded: false,
        }
    },

    mixins: [
        StoreMixin,
    ],

    components: {
        PageHeader,
        PageView,
        PageFooter,
    },

    created() {
        if (this.isLoggedIn) {
            const userJob = new UserJob();
            userJob.init();

            const requiredStoreMurations = ['user/setData', 'organisation/setList'];
            let finishedStoreMutations = 0;
            requiredStoreMurations.forEach(item => {
                this.subscribe(item, () => {
                    finishedStoreMutations++;
                    if (finishedStoreMutations === requiredStoreMurations.length)
                        this.appLoaded = true;
                });
            });
        } else {
            this.appLoaded = true;
        }

        this.$root.$on('root::layout::hideFooter', (hideFooter) => {
            this.hideFooter = hideFooter;
        });
    },

    destroyed() {
        this.$root.$off('root::layout::hideFooter');
    },
})

/* ----------------------------------------
    Export
---------------------------------------- */

export default class Master extends Vue {}

